<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="480"
    >
      <template v-slot:displayAvatar="{ row }">
        <el-avatar
          shape="square"
          :size="50"
          :src="row.contactAvatarUrl || defaultAvatar"
        />
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.contactJob }}</span>
        <br />
        <span>{{ row.contactName }}</span>
      </template>
      <template v-slot:displayMobile="{ row }">
        <span>{{ row.contactMobile }}</span>
        <br />
        <span>{{ row.contactPhone }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.updateByName }}</span>
        <br />
        <span>{{ row.updateTime }}</span>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      tableColumns: tableColumns(this),
    }
  },
}
</script>
